import React from "react";

const AddToCart = ({ handleAddToCart, isRedirecting, defaultText, isDisabled }) => {
  const cartText = isRedirecting ? "Submitting" : defaultText;

  return (
    <div className="add-to-cart">
      <button
        className={`button button--add_to_cart ${isDisabled ? 'disabled' : ''}`}
        onClick={handleAddToCart}
      >
        <div className="add-to-cart__text">{cartText}</div>
        {isRedirecting && (
          <ul className="submitting-spinner">
            <li className="submitting-spinner__dot submitting-spinner__dot--1" />
            <li className="submitting-spinner__dot submitting-spinner__dot--2" />
            <li className="submitting-spinner__dot submitting-spinner__dot--3" />
          </ul>
        )}
      </button>
    </div>
  );
};

export default AddToCart;
